import { PermissionsType } from '@/types/permissions'

export const PermissionModal: PermissionsType = {
  id: '',
  id_user: '',
  permission_product: false,
  permission_geral: false,
  add_user_product: false,
  add_user_client: false,
  add_client: false,
  add_user: false,
  add_contract: false,
  update_product: false,
  update_user: false,
  update_tenant: false,
  update_agreement: false,
  update_analise: false,
  update_client: false,
  update_permissions: false,
  update_user_product: false,
  update_user_client: false,
  delet_product: false,
  delet_user: false,
  delet_tenant: false,
  delet_agreement: false,
  delet_contract: false,
  delet_client: false,
  gerar_boleto: false,
  gerar_analise: false,
  gerar_apuracao: false,
  gerar_nota_fiscal: false,
  export_analise: false,
  export_products: false,
  export_nota_fiscal: false,
  export_boleto: false,
  export_planilha_clients: false,
  pis_cofins_monofasico_para_sn: false,
  previdenciario: false,
  exclusao_icms: false,
  subvencao: false,
  apuracao_st: false,
  negociacao_de_passivos: false,
  despesas_operacionais: false,
  equiparacao_hospitalar: false,
  fcvs: false
}
